import { render, staticRenderFns } from "./EventsFollowAdsTable.vue?vue&type=template&id=09be9dc6&"
import script from "./EventsFollowAdsTable.vue?vue&type=script&lang=ts&"
export * from "./EventsFollowAdsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
